document.addEventListener('DOMContentLoaded', function () {
  (function loadAnimation(e, t, o) {
    const i = parseInt(
        document.body.style.getPropertyValue('--header-sticky-height').replace('px', ''),
      ),
      { animate: n, scroll: r } = window.Motion;
    let s = !1;
    const c = document.getElementById(e),
      l = document.querySelector(`#backdrop-${e}`),
      a = document.querySelector(`#spaces-${e}`),
      u = document.querySelector(`#image-${e}`),
      d = document.querySelector(`#sub-spaces-${e}`),
      h = document.querySelector(`#${t}`),
      f = document.querySelector(`#filters-${e}`);

    if (!(c && a && l && h && f)) return;

    async function p() {
      const e = s ? 46.67 : 17.71;
      if (!a) return;
      if (u) {
        const c = a.scrollHeight + window.innerWidth * (e / 100);
        (n(
          a,
          {
            height: ['0px', c],
            opacity: [0, 1],
          },
          {
            duration: 1,
          },
        ),
          n(
            d,
            {
              height: ['0px', `${e}vw`],
              opacity: [0, 1],
            },
            {
              duration: 1,
            },
          ),
          n(
            u,
            {
              opacity: [0, 1],
            },
            {
              duration: 1,
            },
          ),
          'white' === o &&
            n(
              h,
              {
                '--color-text': ['#000', '#fff'],
                '--inverse-color-text': ['#fff', '#000'],
              },
              {
                duration: 1,
              },
            ),
          await ((t = 1e3), new Promise((e) => setTimeout(e, t))),
          globalThis.requestAnimationFrame(() => {
            !(function () {
              const e = s ? 46.67 : 17.71;
              if (!u) return;
              if (!l) return;
              if (!a) return;
              if (!h) return;
              const t = window.innerWidth * (e / 100),
                c = u.getBoundingClientRect().height;
              l.style.top = `${c + i}px`;
              l.style.display = 'block';
              l.offsetHeight; // Force reflow

              console.log('Element l:', l);
              console.log('Element l computed style:', getComputedStyle(l));
              console.log('Values - c:', c, 'i:', i);

              const d = n(l, {
                opacity: [0, 1],
                height: [0, c + i],
                top: [c + i, i],
              });

              console.log('Animation object:', d);
              if ('white' === o) {
                const e = n(h, {
                  '--color-text': ['#fff', '#000'],
                  '--inverse-color-text': ['#000', '#fff'],
                });
                r(e, {
                  offset: ['0px', t - 50 + 'px'],
                });
              }
              r(d, {
                offset: ['0px', t - 50 + 'px'],
              });
            })();
          }));
      } else {
        const e = a.scrollHeight;
        n(
          a,
          {
            height: ['0px', e],
            opacity: [0, 1],
          },
          {
            duration: 1,
          },
        );
      }
      var t;
      const c = /iPad|iPhone|iPod/.test(navigator.userAgent),
        f = window.innerWidth > 640;
      c &&
        f &&
        globalThis.addEventListener(
          'resize',
          (function (e, t) {
            let o;
            return function (...i) {
              (clearTimeout(o), (o = setTimeout(() => e.apply(this, i), t)));
            };
          })(() => {
            (console.log('resize'),
              (a.style.height = '0px'),
              (a.style.opacity = '0'),
              (d.style.height = '0px'),
              (d.style.opacity = '0'),
              u && (u.style.opacity = '0'),
              'white' === o &&
                (h.style.setProperty('--color-text', '#000'),
                h.style.setProperty('--inverse-color-text', '#fff')),
              p());
          }, 100),
        );
    }

    'complete' === document.readyState
      ? ((s = window.innerWidth < 640),
        globalThis.requestAnimationFrame(() => {
          p();
        }))
      : globalThis.addEventListener('load', () => {
          ((s = window.innerWidth < 640),
            globalThis.requestAnimationFrame(() => {
              p();
            }));
        });
  })('P0-6', 'P0-5947904', 'white');
});
